module.exports = __webpack_public_path__ + "img/3.ef540ed1.jpg";